import './estatefarrington/style';
import FormStructure from './estatefarrington/form_structure';

export default FormStructure;